import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const userFollowerApiService = createApi({
  reducerPath: "userFollowerApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createUserFollower: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `userfollowers/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getFollowersByUserId: builder.query({
      query: ({ params }) => {
        let query = queryParams(params);
        return {
          url: `userfollowers${query}`,
          method: "GET",
        };
      },
    }),
    updateFollower: builder.mutation({
      query: ({ id, payload, params }) => {
        let query = queryParams(params);
        return {
          url: `userfollowers/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const {
  useCreateUserFollowerMutation,
  useGetFollowersByUserIdQuery,
  useUpdateFollowerMutation,
} = userFollowerApiService;
